import React from "react";
import { useGetInvestigationDetails } from "security-app/hooks/useInvestigationsAPI";
function LoadAssociatedInvestigationsFilterLabel({ invId }) {
  const { currentInvestigation, loadingInvestigationDetails, fetchError } = useGetInvestigationDetails(invId);
  if (loadingInvestigationDetails) {
    return /* @__PURE__ */ React.createElement("span", null, "Loading investigation\u2026");
  }
  if (fetchError || !currentInvestigation) {
    return /* @__PURE__ */ React.createElement("span", null, "Investigation not available");
  }
  return /* @__PURE__ */ React.createElement("span", null, currentInvestigation.name);
}
function AssociatedInvestigationsFilterLabel({ invId }) {
  if (invId === null || invId === "null") {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("i", null, "none"));
  }
  return LoadAssociatedInvestigationsFilterLabel({ invId });
}
export default AssociatedInvestigationsFilterLabel;
